<div class="community-messages container-xl py-3" *transloco="let t">
  <header class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
    <div>
      <h1 class="h3 mb-0">✉️ {{ t('community.messages.title') }}</h1>
    </div>
    <div class="d-flex gap-2">
      <a class="btn btn-outline-secondary btn-sm" [routerLink]="communityLink()">← {{ t('community.thread.back') }}</a>
      <a class="btn btn-primary btn-sm" [routerLink]="composeLink()">{{ t('community.messages.new') }}</a>
    </div>
  </header>

  @if (error(); as key) {
    <div class="alert alert-danger d-flex justify-content-between align-items-start">
      <span>{{ t(key) }}</span>
      <button type="button" class="btn-close" (click)="error.set(null)"></button>
    </div>
  }

  <ul class="nav nav-tabs mb-3">
    @for (v of views; track v) {
      <li class="nav-item">
        <button type="button" class="nav-link" [class.active]="view() === v" (click)="selectView(v)">
          {{ t('community.messages.view.' + v) }}
        </button>
      </li>
    }
  </ul>

  @if (loading()) {
    <div class="text-center py-4"><div class="spinner-border" role="status"></div></div>
  } @else if (messages().length === 0) {
    <p class="text-muted">{{ t('community.messages.empty') }}</p>
  } @else {
    <div class="list-group">
      @for (m of messages(); track m.id) {
        <a class="list-group-item list-group-item-action community-messages__row" [class.community-messages__row--unread]="view() !== 'sent' && !m.is_read"
           [routerLink]="detailLink(m.id)">
          <app-community-avatar [user]="counterpart(m)" [size]="36" />
          <div class="community-messages__body">
            <div class="d-flex justify-content-between gap-2">
              <span class="community-messages__from">{{ counterpart(m).full_name || counterpart(m).username || '—' }}</span>
              <span class="text-muted small text-nowrap">{{ m.created_at | date:'short' }}</span>
            </div>
            <div class="community-messages__subject">
              @if (view() !== 'sent' && !m.is_read) { <span class="badge bg-danger me-1">{{ t('community.messages.unread') }}</span> }
              {{ m.subject }}
            </div>
          </div>
          <button type="button" class="btn btn-sm btn-outline-secondary community-messages__archive" [disabled]="busy()" (click)="toggleArchive(m, $event)">
            {{ view() === 'archive' ? t('community.messages.unarchive') : t('community.messages.archive') }}
          </button>
        </a>
      }
    </div>

    <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-3">
      <small class="text-muted">{{ t('community.moderation.total', { count: total() }) }}</small>
      @if (totalPages() > 1) {
        <nav class="d-flex gap-2">
          <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="page() <= 1" (click)="load(page() - 1)">‹</button>
          <span class="align-self-center small text-muted">{{ page() }} / {{ totalPages() }}</span>
          <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="page() >= totalPages()" (click)="load(page() + 1)">›</button>
        </nav>
      }
    </div>
  }
</div>
